'use client';

import { cn } from '@/lib/utils';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import * as React from 'react';
import tabsStyles from './tabs.module.scss';

const Tabs = ({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Root>): React.JSX.Element => {
  return (
    <TabsPrimitive.Root className={cn(tabsStyles.tabs, className)}
      data-slot="tabs"
      {...props}
    />
  );
};

const TabsList = ({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List>): React.JSX.Element => {
  return (
    <TabsPrimitive.List className={cn(tabsStyles['tabs-list'], className)}
      data-slot="tabs-list"
      {...props}
    />
  );
};

const TabsTrigger = ({
  asChild,
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>): React.JSX.Element => {
  const triggerProps = asChild
    ? { ...props, 'aria-controls': undefined }
    : props;

  return (
    <TabsPrimitive.Trigger asChild={asChild}
      // FIXME: As long as no visual regression is found, we can add text-base class here to make all tabs triggers consistent (PBI-133647)
      className={cn(tabsStyles['tabs-trigger'], 'h3', className)}
      data-slot="tabs-trigger"
      {...triggerProps}
    />
  );
};

const TabsContent = ({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>): React.JSX.Element => {
  return (
    <TabsPrimitive.Content className={cn('flex-1 outline-none', className)}
      data-slot="tabs-content"
      {...props}
    />
  );
};

export { Tabs, TabsContent, TabsList, TabsTrigger };
